import { render, staticRenderFns } from "./AsCharts.component.vue?vue&type=template&id=4ca9067a&scoped=true&"
import script from "./AsCharts.component.vue?vue&type=script&lang=js&"
export * from "./AsCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./AsCharts.component.vue?vue&type=style&index=0&id=4ca9067a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca9067a",
  null
  
)

export default component.exports